import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { BASE_PATH, DASHBOARD_PATH } from 'config';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const handlePlanRedirect = (navigate) => {
  const plan = JSON.parse(localStorage.getItem("selectedPlan"));
  if (plan) {
    navigate("/payment", { replace: true });
  } else {
    navigate(DASHBOARD_PATH, { replace: true });
    console.log('go to dashboard path')
  }
};

const GuestGuard = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const currentRoute = window.location.pathname;

  // useEffect(() => {
  //   console.log(currentRoute);
  // }, [currentRoute]);

  useEffect(() => {
    console.log(user)
    if (user !== null) {
      handlePlanRedirect(navigate);
    }
  }, [user, navigate]);

  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
